import { useQuery } from 'react-query';

import { TRIAL_QUERY_KEYS } from '../../constants';
import { fetchTrialStatus, TrialStatusResponse } from '../../request';

/**
 * Login gate — resolved once per session. Refetching would re-run the bootstrap
 * gate behind the user's back, so the result is kept fresh for the whole session.
 */
export const useGetTrialStatus = (enabled: boolean) =>
  useQuery<TrialStatusResponse, Error>(
    [TRIAL_QUERY_KEYS.STATUS],
    ({ signal }) => fetchTrialStatus(signal),
    { enabled, staleTime: Infinity }
  );
